import React from "react";

const BarraDePasos = (props) => {
  const { paso, isCDR } = props;
  return (
    <div className={`breadcrumbs ${isCDR ? 'breadcrumbsCDR' : ''}`}>
      <ul className="row">
        <li className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
          <div className={"number " + (paso === "1" ? "active" : "")}>
            <span>1</span>
            <hr />
          </div>
          <p className={paso === 1 ? "text-active" : ""}>Log-in</p>
        </li>
        <li className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
          <div className={"number " + (paso === "2" ? "active" : "")}>
            <span>2</span>
            <hr />
          </div>
          <p className={paso === 2 ? "text-active" : ""}>
            Carga de pasajeros
          </p>
        </li>
        <li className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
          <div className={"number " + (paso === "3" ? "active" : "")}>
            <span>3</span>
            <hr />
          </div>
          <p className={paso === 3 ? "text-active" : ""}>Pago</p>
        </li>
        <li className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
          <div className={"number " + (paso === "4" ? "active" : "")}>
            <span>4</span>
            <hr />
          </div>
          <p className={paso === "4" ? "text-active" : ""}>
            Fin de la compra
          </p>
        </li>
      </ul>
    </div>
  );
};

export default BarraDePasos;



// WEBPACK FOOTER //
// ./src/components/Global/BarraDePasos.js